import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-[#FAFBFC] py-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium mb-8 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Torna alla home
        </Link>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
          Cookie Policy
        </h1>

        <div className="prose prose-gray max-w-none">
          <p className="text-gray-500 mb-8">
            Ultimo aggiornamento: Aprile 2026
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Cosa sono i Cookie</h2>
            <p className="text-gray-600 leading-relaxed">
              I cookie sono piccoli file di testo che i siti visitati inviano al browser dell'utente, 
              dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. 
              I cookie sono utilizzati per diverse finalità, hanno caratteristiche diverse, e possono essere 
              utilizzati sia dal titolare del sito che si sta visitando, sia da terze parti.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Tipologie di Cookie Utilizzati</h2>
            
            <h3 className="text-lg font-medium text-gray-800 mb-3 mt-6">2.1 Cookie Tecnici (Necessari)</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Questi cookie sono essenziali per il corretto funzionamento del sito e non possono essere disattivati. 
              Includono:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
              <li><strong>Cookie di sessione</strong> - permettono la navigazione e l'utilizzo delle funzionalità base</li>
              <li><strong>Cookie di preferenze</strong> - memorizzano le scelte dell'utente (es. consenso cookie)</li>
            </ul>
            <p className="text-gray-600 leading-relaxed">
              <strong>Base giuridica:</strong> Legittimo interesse (Art. 6.1.f GDPR) - non richiedono consenso
            </p>

            <h3 className="text-lg font-medium text-gray-800 mb-3 mt-6">2.2 Cookie Analitici</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Questi cookie ci permettono di contare le visite e le fonti di traffico per misurare e migliorare 
              le prestazioni del sito. Se non accetti questi cookie, non sapremo quando hai visitato il nostro sito.
            </p>
            <p className="text-gray-600 leading-relaxed">
              <strong>Base giuridica:</strong> Consenso dell'utente (Art. 6.1.a GDPR)
            </p>

            <h3 className="text-lg font-medium text-gray-800 mb-3 mt-6">2.3 Cookie di Marketing</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Attualmente il sito <strong>non utilizza</strong> cookie di marketing o profilazione di terze parti.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Durata dei Cookie</h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li><strong>Cookie di sessione</strong> - vengono cancellati alla chiusura del browser</li>
              <li><strong>Cookie persistenti</strong> - rimangono memorizzati fino alla loro scadenza o cancellazione da parte dell'utente</li>
              <li><strong>Cookie di consenso</strong> - durata 12 mesi</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Gestione dei Cookie</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              L'utente può gestire le preferenze sui cookie in diversi modi:
            </p>
            
            <h3 className="text-lg font-medium text-gray-800 mb-3 mt-4">4.1 Tramite il Banner Cookie</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Al primo accesso al sito viene mostrato un banner che permette di accettare o rifiutare i cookie non essenziali.
            </p>

            <h3 className="text-lg font-medium text-gray-800 mb-3 mt-4">4.2 Tramite le Impostazioni del Browser</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              È possibile bloccare o eliminare i cookie attraverso le impostazioni del browser:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Microsoft Edge</a></li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Cookie di Terze Parti</h2>
            <p className="text-gray-600 leading-relaxed">
              Il sito potrebbe contenere link a siti web di terze parti. Questi siti hanno le proprie cookie policy 
              e norme sulla privacy, sulle quali non abbiamo controllo. Ti invitiamo a consultare le rispettive 
              informative prima di fornire i tuoi dati personali.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Diritti dell'Utente</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              In relazione ai dati raccolti tramite cookie, l'utente può esercitare i diritti previsti dal GDPR 
              (accesso, rettifica, cancellazione, limitazione, portabilità, opposizione) contattando:
            </p>
            <p className="text-gray-600">
              <strong>SeagullByte</strong><br />
              Email: <a href="mailto:info@seagullbyte.it" className="text-blue-600 hover:underline">info@seagullbyte.it</a><br />
              P.IVA: 01295100950
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Aggiornamenti</h2>
            <p className="text-gray-600 leading-relaxed">
              Questa Cookie Policy può essere aggiornata periodicamente. La data dell'ultimo aggiornamento 
              è indicata in cima a questa pagina. Ti invitiamo a consultare regolarmente questa pagina 
              per essere informato su eventuali modifiche.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
